<div class="relative mb-3 flex h-16 justify-end py-2 px-3 shadow">
  <button
    (click)="closeMenu()"
    aria-label="Stäng"
    class="icon-button"
    type="button"
  >
    <app-ui-icon color="var(--grey-1)" name="close"></app-ui-icon>
  </button>
</div>

<div class="min-w-[15rem] max-w-xs">
  <a
    (click)="closeMenu()"
    [indexedLink]="['/']"
    [routerLink]="['/', 'minasidor']"
    [targetParams]="{}"
    [targetUrl]="['/', 'minasidor']"
    appIndexedLink
    aria-label="Mina sidor"
    class="sidebar-link md:hidden"
    rel="nofollow"
    title="Mina sidor"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="employee"></app-ui-icon>
    <div class="flex flex-col">
      <span>Mina sidor</span>
      <p *ngIf="profile()" class="text-xs font-normal text-grey-1">
        {{ profile().given_name }} {{ profile().family_name }}
      </p>
    </div>
  </a>

  <a
    (click)="closeMenu()"
    aria-label="Chatt"
    class="sidebar-link"
    href="https://chatt.varden.se/"
    title="Chatt"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="bot"></app-ui-icon>
    <span>Chatt <sup class="text-apricot-5 font-black">ny!</sup></span>
  </a>
  <a
    (click)="closeMenu()"
    [routerLink]="['/', 'blogg']"
    aria-label="Blogg"
    class="sidebar-link"
    title="Blogg"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="newspaper"></app-ui-icon>
    Blogg
  </a>
  <a
    (click)="closeMenu()"
    [routerLink]="['/', 'artiklar']"
    aria-label="Artiklar"
    class="sidebar-link"
    title="Artiklar"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="articles"></app-ui-icon>
    Artiklar
  </a>
  <a
    (click)="closeMenu()"
    [routerLink]="['/', 'guider']"
    aria-label="Guider"
    class="sidebar-link"
    title="Guider"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="user_manual"></app-ui-icon>
    Guider
  </a>
  <a
    (click)="closeMenu()"
    aria-label="Anslut mottagning"
    class="sidebar-link md:hidden"
    href="https://vardgivare.varden.se/"
    title="Anslut mottagning"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="hospital"></app-ui-icon>
    Anslut mottagning
  </a>

  <button
    (click)="onLogout()"
    *ngIf="profile() != null"
    aria-label="Logga ut"
    class="flex w-full gap-4 border-2 border-transparent py-3 px-6 font-medium text-grey-1 outline-0 transition hover:bg-grey-10 focus:border-green-4 active:bg-green-5"
    title="Logga ut"
  >
    <app-ui-icon color="var(--grey-1)" name="logout"></app-ui-icon>
    Logga ut
  </button>

  <a
    (click)="closeMenu()"
    [routerLink]="['/',RoutesEnums.RELATED, RoutesAddonsEnums.RELATED_CAREPROVIDER]"
    [title]="RoutesNamesEnum.RELATED_CAREPROVIDER"
    class="sidebar-link"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="arrow_right"></app-ui-icon>
    {{ RoutesNamesEnum.RELATED_CAREPROVIDER }}
  </a>

  <a
    (click)="closeMenu()"
    [routerLink]="['/',RoutesEnums.RELATED, RoutesAddonsEnums.RELATED_CARESERVICE]"
    [title]="RoutesNamesEnum.RELATED_CARESERVICE"
    class="sidebar-link"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="arrow_right"></app-ui-icon>
    {{ RoutesNamesEnum.RELATED_CARESERVICE }}
  </a>

  <a
    (click)="closeMenu()"
    [routerLink]="['/',RoutesEnums.RELATED, RoutesAddonsEnums.RELATED_SYMPTOM]"
    [title]="RoutesNamesEnum.RELATED_SYMPTOM"
    class="sidebar-link"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="arrow_right"></app-ui-icon>
    {{ RoutesNamesEnum.RELATED_SYMPTOM }}
  </a>

  <a
    (click)="closeMenu()"
    aria-label="Aposmart"
    class="sidebar-link"
    href="https://www.aposmart.se"
    title="Aposmart"
  >
    <app-ui-icon class="md" color="var(--grey-1)" name="website"></app-ui-icon>
    Aposmart
  </a>
</div>
